import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Drawer, Card, Container, Grid, Typography, Button, DialogContentText, Dialog, DialogContent, List, ListItem, ListItemIcon, ListItemText, CardContent, Avatar } from '@mui/material';
import { CheckCircle, CheckCircleOutline } from '@mui/icons-material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
import useCollapseDrawer from '../../../hooks/useCollapseDrawer';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { NAVBAR } from '../../../config';
import Scrollbar from '../../../components/Scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
//
import navConfig from './NavConfig';
import Logo from '../../../images/dummy_profile.png';
import HeadHunting from '../../../images/headhunting_5.png'

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------
// Yash_raj_logo.png

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();
  const [selectedUser, setSelectedUser] = useState('');
  const [updateImg, setUpdateImg] = useState('');
  const { pathname } = useLocation();
  const [company_type, setCompany_type] = useState('');
  const [company_name, setCompany_name] = useState('');
  const [companyProfile, setCompanyProfile] = useState('No');
  const [companyTypeData, setCompanyTypeData] = useState({});

  const isDesktop = useResponsive('up', 'lg');

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();

  const { currentUser, profileImageData, usermenuDashboard, userProfileDashboard, getProjectJob, CompTabs, getWebsite, ComplTabsRes, getAccountSetting } = useSelector((state) => {
    return {
      currentUser: state && state.profile && state.profile.events && state.profile.events.response,
      profileImageData: state && state.profile && state.profile.profileImage,
      usermenuDashboard: state && state.profile && state.profile.dashboardDataSucc && state.profile.dashboardDataSucc.response && state.profile.dashboardDataSucc.response.menu,
      userProfileDashboard: state && state.profile && state.profile.dashboardDataSucc && state.profile.dashboardDataSucc.response,
      getProjectJob: state && state.myjob && state.myjob.getProjectResp && state.myjob.getProjectResp.response,
      CompTabs: state && state.calendar && state.calendar.events && state.calendar.events.completion_tabs,
      getWebsite: state && state.companyprofile && state.companyprofile.aboutUsWebSuccess && state.companyprofile.aboutUsWebSuccess && state.companyprofile.aboutUsWebSuccess.response,
      ComplTabsRes: state && state.staff && state.staff.getMyStaffList && state.staff.getMyStaffList.response,
      getAccountSetting: state && state.settings && state.settings.account && state.settings.account.data && state.settings.account.data.response,
    };
  });

  useEffect(() => {
    if (currentUser && currentUser !== undefined && currentUser.get_employer_data) {
      setSelectedUser(currentUser.get_employer_data);
      if (currentUser.get_employer_data && currentUser.get_employer_data.avatar_url) {
        setUpdateImg(currentUser.get_employer_data.avatar_url);
      }
      if (currentUser.company_data && Object.keys(currentUser.company_data).length > 0) {
        setCompanyTypeData(currentUser.company_data);
      }
      if (currentUser.completion_tabs && currentUser.completion_tabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (userProfileDashboard && userProfileDashboard !== undefined) {
      if (userProfileDashboard.completion_tabs && userProfileDashboard.completion_tabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [userProfileDashboard]);

  useEffect(() => {
    if (getProjectJob && getProjectJob !== undefined) {
      if (getProjectJob.completion_tabs && getProjectJob.completion_tabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [getProjectJob]);

  useEffect(() => {
    if (getWebsite && getWebsite !== undefined) {
      if (getWebsite.completion_tabs && getWebsite.completion_tabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [getWebsite]);

  useEffect(() => {
    if (ComplTabsRes && ComplTabsRes !== undefined) {
      if (ComplTabsRes.completion_tabs && ComplTabsRes.completion_tabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [ComplTabsRes]);

  useEffect(() => {
    if (getAccountSetting && getAccountSetting !== undefined) {
      if (getAccountSetting.completion_tabs && getAccountSetting.completion_tabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [getAccountSetting]);

  useEffect(() => {
    if (CompTabs && CompTabs !== undefined) {
      if (CompTabs && CompTabs.length === 2) {
        setCompanyProfile("Yes");
        localStorage.setItem('companyProfileFilled', 'Yes');
      }
    }
  }, [CompTabs]);

  console.log(CompTabs, 'CompTabs87568')

  // useEffect(() => {
  //   if (profileImageData && profileImageData.response && profileImageData.response.avatar_url && profileImageData.response.avatar_url!=='') {
  //     console.log(profileImageData.response,'profileImageData')
  //     setUpdateImg(profileImageData.response.avatar_url);
  //   }
  // }, [profileImageData]);


  useEffect(() => {
    if (currentUser !== "") {
      setTimeout(() => {
        const companyType = localStorage.getItem('companyType');
        const CompanyName = localStorage.getItem('CompanyName');
        const CompanyFilledORNot = localStorage.getItem('companyProfileFilled');
        if (CompanyFilledORNot && CompanyFilledORNot !== '' && CompanyFilledORNot !== undefined && CompanyFilledORNot !== null) {
          if (CompanyFilledORNot === 'Yes') {
            setCompanyProfile("Yes");
          }
        }
        console.log(CompanyFilledORNot, 'CompanyFilledORNot363')
        setCompany_type(companyType);
        setCompany_name(CompanyName);

      }, 1000);
    }
  }, [currentUser])



  // const userProfessionName1 = localStorage.getItem('userProfessionName');
  // useEffect(() =>{
  //     setTimeout(() => {
  //      const userProfessionName = localStorage.getItem('userProfessionName');
  //      setProfessionName(userProfessionName)
  //     }, 1000);
  //  },[userProfessionName1])


  useEffect(() => {
    if (profileImageData !== "") {
      setTimeout(() => {
        const userPhotourl = localStorage.getItem('userPhotourlEmp');
        setUpdateImg(userPhotourl)
      }, 1000);
    }
  }, [profileImageData])

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);


  const renderContent = (
    <Scrollbar
      className='sideBar'
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      {/* <Stack 
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: 'center' }),
        }}
      >
        <Stack  direction="row" alignItems="center" justifyContent="space-between">       

         {isDesktop && !isCollapse && (
            <CollapseButton onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />
          )} 
        </Stack>

        <NavbarAccount isCollapse={isCollapse} />
      </Stack> */}

      <NavSectionVertical navConfig={navConfig} isCollapse={isCollapse} IsProfile={companyProfile} />

      <Box sx={{ flexGrow: 1 }} />

    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
        }),
      }}
    >
      {/* {!isDesktop && (
        <>
          {companyProfile && companyProfile === 'Yes' ?
            <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}>
              {renderContent}
            </Drawer>
            :
            <Drawer
              open
              variant="persistent"
              onMouseEnter={onHoverEnter}
              onMouseLeave={onHoverLeave}
              PaperProps={{
                sx: {
                  width: NAVBAR.DASHBOARD_WIDTH,
                  borderRightStyle: 'solid',
                  top: 80,
                  // bgcolor: 'background.default',
                  transition: (theme) =>
                    theme.transitions.create('width', {
                      duration: theme.transitions.duration.standard,
                    }),
                  ...(isCollapse && {
                    width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                  }),
                  ...(collapseHover && {
                    ...cssStyles(theme).bgBlur(),
                    boxShadow: (theme) => theme.customShadows.z24,
                  }),
                },
              }}>
              {''}
            </Drawer>
          }
        </>
      )} */}

      {!isDesktop && (
        <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH, bgcolor: '#001892' } }}>
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <>
          {companyProfile && companyProfile === 'Yes' ?
            <Drawer
              open
              variant="persistent"
              onMouseEnter={onHoverEnter}
              onMouseLeave={onHoverLeave}
              PaperProps={{
                sx: {
                  width: NAVBAR.DASHBOARD_WIDTH,
                  borderRightStyle: 'solid',
                  top: 80,
                  bgcolor: 'background.default',
                  transition: (theme) =>
                    theme.transitions.create('width', {
                      duration: theme.transitions.duration.standard,
                    }),
                  ...(isCollapse && {
                    width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                  }),
                  ...(collapseHover && {
                    ...cssStyles(theme).bgBlur(),
                    boxShadow: (theme) => theme.customShadows.z24,
                  }),
                },
              }}
            >
              <Box sx={{ minHeight: '110px', backgroundColor: '#f7f6f9' }}>
                <Card sx={{ m: 1, p: "5px", marginTop: "15px", minHeight: "65px" }} className="isLogoBoxShadow">
                  {/* <Grid container spacing={2}>
                    <Grid item md={4}>
                      <Box sx={{ ml: 2, mt: 1.5 }}>
                        {console.log(updateImg, 'updateImg')}
                        <img
                          src={updateImg && updateImg !== '' ? updateImg : Logo}
                          alt="logo" style={{ height: "40px", textAlign: 'center', borderRadius: "50px", p: 1 }} />
                      </Box>
                    </Grid>
                    <Grid item md={8} sx={{ mt: 1 }}>
                      <Typography sx={{ fontSize: "11px", color: "#777777" }}>EMPLOYER DASHBOARD </Typography>
                      <Typography sx={{ fontSize: "14px", color: "#777777", fontWeight: "bold" }}>{company_name && company_name !== '' ?
                        <span>{company_name.length > 18 ? company_name.substring(0, 18).concat("...") : company_name} </span> : 'Company Name'} </Typography>

                      <Typography sx={{ fontSize: "12px", color: "#777777" }}>{company_type && company_type !== '' ?
                        <span>{company_type.length > 18 ? company_type.substring(0, 18).concat("...") : company_type} </span> : ''} </Typography>

                    </Grid>
                  </Grid> */}
                  <Grid container alignItems={'center'}>
                    <Grid item md={4}>
                      <Box >
                        <Avatar
                          alt="logo"
                          className='NavbarAvatar'
                          src={updateImg && updateImg !== '' ? updateImg : Logo}
                          sx={{ width: 60, height: 60 }}
                        />
                      </Box>
                    </Grid>
                    <Grid item md={8} sx={{ mt: "7px" }}>
                      <Typography gutterBottom sx={{ fontSize: "11px", color: "#777777" }}>EMPLOYER DASHBOARD </Typography>
                      <Typography sx={{ fontSize: "15px", color: "black", fontWeight: "600" }}>{company_name && company_name !== '' ?
                        <span>{company_name.length > 18 ? company_name.substring(0, 18).concat("...") : company_name} </span> : 'Company Name'} </Typography>

                      <Typography sx={{ fontSize: "12.5px", color: "#777777" }}>{company_type && company_type !== '' ?
                        <span>{company_type.length > 18 ? company_type.substring(0, 18).concat("...") : company_type} </span> : ''} </Typography>

                    </Grid>
                  </Grid>
                </Card>
              </Box>
              {renderContent}
            </Drawer>
            :
            <Drawer
              open
              variant="persistent"
              onMouseEnter={onHoverEnter}
              onMouseLeave={onHoverLeave}
              PaperProps={{
                sx: {
                  width: NAVBAR.DASHBOARD_WIDTH,
                  borderRightStyle: 'solid',
                  top: 80,
                  // bgcolor: 'background.default',
                  transition: (theme) =>
                    theme.transitions.create('width', {
                      duration: theme.transitions.duration.standard,
                    }),
                  ...(isCollapse && {
                    width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                  }),
                  ...(collapseHover && {
                    ...cssStyles(theme).bgBlur(),
                    boxShadow: (theme) => theme.customShadows.z24,
                  }),
                },
              }}>
              <Box sx={{ minHeight: '110px', backgroundColor: '#f7f6f9' }}>
                <Card sx={{ m: 1, mt: 2, p: 1, mb: 0, pr: 5, minHeight: "80px" }} className="isLogoBoxShadow">
                  <Grid container md={12}>
                    <Grid item md={4}>
                      <Box sx={{ ml: 2, mt: 1.5 }}>
                        {console.log(updateImg, 'updateImg')}
                        <img
                          src={updateImg && updateImg !== '' ? updateImg : Logo}
                          alt="logo" style={{ height: "40px", textAlign: 'center', borderRadius: "50px", p: 1 }} />
                      </Box>
                    </Grid>
                    <Grid item md={8} sx={{ mt: 1 }}>
                      <Typography sx={{ fontSize: "11px", color: "#777777" }}>EMPLOYER DASHBOARD</Typography>
                      <Typography sx={{ fontSize: "14px", color: "#777777", fontWeight: "bold" }}>{company_name && company_name !== '' ?
                        <span>{company_name.length > 18 ? company_name.substring(0, 18).concat("...") : company_name} </span> : 'Company Name'} </Typography>

                      <Typography sx={{ fontSize: "12px", color: "#777777" }}>{company_type && company_type !== '' ?
                        <span>{company_type.length > 18 ? company_type.substring(0, 18).concat("...") : company_type} </span> : ''} </Typography>

                    </Grid>
                  </Grid>
                </Card>
              </Box>
              <Grid item xs={12} sm={6} md={4}>
                <Box style={{ backgroundColor: "#eef3fe", height: "100%", position: "relative" }}>
                  <Box py={1} style={{ height: "100%" }}>
                    <Typography className='font-weight-bold' style={{ fontSize: "1rem" }} align='center'>{companyTypeData.name} </Typography>
                    <Box mt={2} style={{ display: "flex", justifyContent: "center" }}>
                      <img src={HeadHunting} alt="head hunting" className='img-fluid' style={{ width: '48%' }} />
                    </Box>
                    <Box p={1}>
                      <List>
                        {companyTypeData.description && companyTypeData.description.length > 0 ? companyTypeData.description.map((row) => {
                          return (
                            <ListItem style={{ padding: "6px 16px" }}>
                              <ListItemIcon style={{ marginRight: "0.5rem" }}>
                                <CheckCircleOutline style={{ color: "#56bcab", fontSize: "1rem" }} />
                              </ListItemIcon>
                              <ListItemText primary={row} style={{ color: "#000", fontWeight: 500 }} />
                            </ListItem>
                          )

                        })
                          : ""}
                      </List>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Drawer>
          }
        </>
      )}
    </RootStyle>
  );
}
